import React, { useState, Fragment } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { themes } from 'kb-shared';
import { useTranslation } from 'react-i18next';

import InsuranceCardUploadModal from './InsuranceCardUploadModal';
import WhiteSquare from '../../WhiteSquare';

const ShowModalButton = styled.a`
  background: none;
  border: none;
  height: 140px;
  padding: 0;
  margin: 0;
  width: 140px;
`;

const Description = styled.small`
  ${themes.fonts.FoundersGrotesk};
  max-width: 140px;
  display: inline-block;
  text-align: center;
  margin: 8px 0 0 0;
`;

const InsuranceCardUploadButton = () => {
  const [showingModal, setShowingModal] = useState<boolean>(false);
  const { t } = useTranslation();

  const showModal = () => {
    setShowingModal(true);
  };

  const body = document.body;
  if (!body) return null;

  return (
    <Fragment>
      <ShowModalButton onClick={showModal}>
        <WhiteSquare />
      </ShowModalButton>
      {showingModal &&
        ReactDOM.createPortal(
          <InsuranceCardUploadModal
            onClose={() => {
              setShowingModal(false);
            }}
          />,
          body
        )}
      <Description>{t('upload_button.help_text', { megabytes: 2 })}</Description>
    </Fragment>
  );
};

export default InsuranceCardUploadButton;
